import { getElementById, reloadWindow } from "../services/dom";
import navbarTemplate from "../templates/sections/navbar.html?raw";
import sync_motion from "../assets/sync_motion.gif";
import cloud_saved from "../assets/cloud_saved.svg";
import cloud_save_error from "../assets/cloud_save_error.svg";
import sync_static from "../assets/sync_static.svg";
import logoUrl from "../assets/logo.png";

export default class NavBar extends HTMLElement {
  constructor() {
    super();

    const navbarLinks: any[] = [
      // {
      //   name: "Home",
      //   href: "/",
      // },
    ];

    const container = getElementById("section-navbar");
    container.classList.add("mx-auto", "px-2");
    container.innerHTML = navbarTemplate;

    // Set up Web MenuBlock
    const webMenuBlock = getElementById("webMenu");
    navbarLinks.forEach((link) => {
      const linkOuter = document.createElement("div");
      linkOuter.classList.add("text-gray-300", "hover:bg-gray-700", "hover:text-white", "block", "px-3", "py-1", "rounded-md", "text-base", "font-medium");
      const linkInner = document.createElement("button");
      linkInner.addEventListener("click", (event) => {
        event.preventDefault();
        (window as any).appRouter.navigate(link.href);
      });
      linkInner.textContent = link.name;
      linkOuter.appendChild(linkInner);
      webMenuBlock.appendChild(linkOuter);
    });

    // Set up Mobile MenuBlock
    const mobileMenuBlock = getElementById("mobileMenu");
    navbarLinks.forEach((link) => {
      const linkOuter = document.createElement("div");
      linkOuter.classList.add("text-gray-300", "hover:bg-gray-700", "hover:text-white", "block", "px-3", "rounded-md", "text-base", "font-medium");
      const linkInner = document.createElement("a");
      linkInner.addEventListener("click", (event) => {
        event.preventDefault();
        (window as any).appRouter.navigate(link.href);
      });
      linkInner.textContent = link.name;
      linkOuter.appendChild(linkInner);
      mobileMenuBlock.appendChild(linkOuter);
    });

    // Set up Mobile Menu Toggle
    const button = getElementById("mobile-menu-toggle");
    const mobileMenuIconClosed = container.querySelector("#mobile-menu-icon-closed");
    const mobileMenuIconOpen = container.querySelector("#mobile-menu-icon-open");
    const mobileMenu = container.querySelector("#mobile-menu");
    button.addEventListener("click", () => {
      mobileMenuIconClosed?.classList.toggle("hidden");
      mobileMenuIconClosed?.classList.toggle("block");
      mobileMenuIconOpen?.classList.toggle("hidden");
      mobileMenuIconOpen?.classList.toggle("block");
      mobileMenu?.classList.toggle("hidden");
    });

    // Set up UserMenu
    const userMenuButton = getElementById("userMenuButton");
    const userMenu = getElementById("userMenu");
    userMenuButton.addEventListener("click", () => {
      userMenu.classList.toggle("hidden");
    });

    // Set up Sync Button Listener
    const syncButton = getElementById("cloudSync");
    syncButton.addEventListener("click", async () => {
      await this.syncData();
      setTimeout(async () => {
        await this.reloadPWA();
        }, 2000);
    });

    // Set up Logout Button Listener
    const logoutButton = getElementById("logoutButton");
    logoutButton.addEventListener("click", () => {
      const confirmLogout = confirm("Are you sure you want to log out?");
      if (confirmLogout) {
        // Clear local storage and reload the window
        localStorage.clear();
        reloadWindow();
      }
    });

    // Set up the Profile Button Listener
    const profileButton = getElementById("profileButton");
    profileButton.addEventListener("click", () => {
      (window as any).appRouter.navigate("/profile");
    });

    // Set up Logo
     const logoElement = getElementById("section-logo");
    const logoImgMobile = document.createElement("img");
    logoImgMobile.src = logoUrl;
    logoImgMobile.alt = "Logo";
    logoImgMobile.classList.add("block", "lg:hidden", "h-16", "w-auto");
    logoElement.appendChild(logoImgMobile);

    const logoImgWeb = document.createElement("img");
    logoImgWeb.src = logoUrl;
    logoImgWeb.alt = "Logo";
    logoImgWeb.classList.add("hidden", "lg:block", "h-16", "w-auto");
    logoElement.appendChild(logoImgWeb);
  }

  private async syncData(): Promise<void> {
    console.log("syncing data");
    (document.getElementById("sync_img") as HTMLImageElement).src = sync_motion;

    // do the sync
    try {
      await Promise.all([
       // TODO
      ]);

      // update src tag of sync button to temporarily show cloud saved image
      (document.getElementById("sync_img") as HTMLImageElement).src = cloud_saved;

      setTimeout(() => {
        // update src tag of sync button to show static sync image
        (document.getElementById("sync_img") as HTMLImageElement).src = sync_static;
      }, 2000);
    } catch (error: any) {
      setTimeout(() => {
        (document.getElementById("sync_img") as HTMLImageElement).src = cloud_save_error;

        // update src tag of sync button to show static sync image
        (document.getElementById("sync_img") as HTMLImageElement).src = sync_static;
      }, 2000);
      console.log("error syncing data");
      console.log(error);
    }
  }

  public async reloadPWA(): Promise<boolean> {
    try {
      // Check if service workers are supported
      if ('serviceWorker' in navigator) {
        // Get all service worker registrations
        const registrations = await navigator.serviceWorker.getRegistrations();

        // Unregister all service workers
        const unregisterPromises = registrations.map(registration => registration.unregister());
        await Promise.all(unregisterPromises);

        // Clear the cache
        if ('caches' in window) {
          const cacheKeys = await caches.keys();
          const deleteCachePromises = cacheKeys.map(key => caches.delete(key));
          await Promise.all(deleteCachePromises);
        }

        // Reload the page to trigger registration of the latest service worker
        window.location.reload();
        return true;
      } else {
        console.warn('Service workers are not supported in this browser');
        return false;
      }
    } catch (error) {
      console.error('Failed to update PWA:', error);
      return false;
    }
  }
}

customElements.define("nav-bar", NavBar);
